if (!customElements.get('product-bundles')) {
  class ProductBundles extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.bundles = [...this.querySelectorAll('product-bundle')];
      this.maxQuantity = Number(this.getAttribute('data-max-quantity'));
      this.mainProductSelector = this.closest('main-product-selector-bundle');
      this.statusContainer = this.querySelector('[product-bundles="status"]');
      this.infoString = this.getAttribute('data-selected-string');
      this.infoStringSuccess = this.getAttribute(
        'data-selected-string-success',
      );
      this.debouncedElementsUpdate = debounce(() => this.updateElements(), 300);

      this.updateRemaining();

      this.bundles.forEach((bundle) => {
        bundle.addEventListener(
          'change',
          (e) => this.handleBundleChange(e, bundle),
          { passive: true },
        );
      });
    }

    /**
     * Handle bundle change
     * @param {Object} e Event
     * @param {HTMLElement} bundle
     */
    handleBundleChange(e, bundle) {
      this.updateRemaining();
      //this.updateLabelSpan();

      this.debouncedElementsUpdate();

      this.bundles.forEach((item) => {
        if (item === bundle) {
          return;
        }
      
        var inputNumber = document.getElementById(item.querySelector('input').id).value

        item.updateLimit(
          this.remaining + Number(inputNumber),
        );
      });
    }

    /**
     * Update elements.
     */
    updateElements() {
      this.mainProductSelector?.toggleAddButton(this.remaining > 0);
      this.updateStatus();
    }

    /**
     * Update status.
     */
    updateStatus() {
      let string =
        this.remaining == 0 ? this.infoStringSuccess : this.infoString;

      string = string.replace('{quantity}', this.maxQuantity - this.remaining);
      string = string.replace('{total}', this.maxQuantity);

      this.statusContainer.innerHTML = string;
    }

    /**
     * Update remaining quantity.
     */
    updateRemaining() {
      this.remaining = this.bundles.reduce((val, bundle) => {
        return val - Number(bundle.querySelector('input')?.value);
      }, this.maxQuantity);
    }

    /**
     * Update each label span when the quantity changes.
     
    updateLabelSpan(bundle) {
      this.bundles.forEach((item) => {
        if (item === bundle) {
          return;
        }
        item.querySelector('.selected-qty').innerText =
          item.querySelector('input').value;
      });
    }*/
  }
  customElements.define('product-bundles', ProductBundles);
}

if (!customElements.get('product-bundle')) {
  class ProductBundle extends HTMLElement {
    input = this.querySelector('input');

    constructor() {
      super();
    }

    connectedCallback() {
      this.quantity = this.getAttribute('data-quantity');
      this.interval = this.getAttribute('data-granularity');
      this.input = this.querySelector('input');
      this.limit = Number(this.input.max);
      this.datalistElements = [...this.querySelectorAll('datalist [value]')];

      if (!this.input) {
        return;
      }

      window.addEventListener("pageshow", () => {
        if (this.input) {
          this.input.value = this.input.getAttribute("min") || 0;
        }
      });

      this.input.addEventListener(
        'change',
        () => {
          // This does not allow for the input to select more than the limit.
          if (this.input.value >= this.limit) {
            this.input.value = this.limit;
          }

          this.datalistElements.forEach((element) => {
            element.classList.toggle(
              'selected',
              element.getAttribute('value') == this.input.value,
            );
          });
        },
        { passive: true },
      );
    }

    /**
     * Update limit
     * @param {Number} limit
     * @returns {Void}
     */
    updateLimit(limit = 0) {
      this.limit = limit;

      this.datalistElements.forEach((element) => {
        element.classList.toggle(
          'disabled',
          Number(element.getAttribute('value')) > this.limit,
        );
      });
    }
  }
  customElements.define('product-bundle', ProductBundle);
}

class MainProductSelectorBundle extends ProductSelector {
  constructor() {
    super();

    this.selectors = {
      stickyATC: '[main-product-selector="sticky-atc"]',
      bundleSelect: '[main-product-selector-bundle="product-bundle"]',
      variantName: '[product="variant-string"]',
      purchaseOption: '[name="purchase_option"]',
    };

    this.stickyATC = document.querySelector(this.selectors.stickyATC);
    this.bundleSelects = this.querySelectorAll(this.selectors.bundleSelect);


    this.variantName = document.querySelector(this.selectors.variantName);
  }

  connectedCallback() {
    super.connectedCallback();

    this.updateUnitPrices();
    this.handleStickyATC();

    window.addEventListener('selling-plan-change', (e) => {
      this.updateUnitPrices(e);
      super.updatePrice();
    });

    document.addEventListener(
        'trigger:combined-bundle-replaced',
        this.onBundleReplace.bind(this));

  }

    onBundleReplace() {
      this.bundleSelects = this.querySelectorAll(this.selectors.bundleSelect);
    }

  /**
   * On submit handler.
   *
   * @param {Object} event
   * @returns {Void}
   */
  onSubmitHandler(event) {
    event.preventDefault();
    this.submitButtons.forEach((btn) => btn.classList.add('disabled'));

    const sellingPlanID =
      this.querySelector('[name="selling_plan"]')?.value || undefined;

    let skuSwapTrigger = false;
    let skuSwap;
    let variantIdSKUSwap;

    if(this.querySelector('[data-sku-swap]')) {
      skuSwap = this.querySelector('[data-sku-swap]').getAttribute('data-sku-swap')
      variantIdSKUSwap = this.querySelector('[data-sku-swap]').getAttribute('data-sku-swap-variant-id')
      skuSwapTrigger = true;
    }

    let bundleProductData = {};

    if(skuSwapTrigger) {
      if(this.currentVariant.id == Number(variantIdSKUSwap) && sellingPlanID){
        bundleProductData = {
          variantId: `${skuSwap}`,
          productId: `${this.getAttribute('data-product-id')}`,
          sellingPlan: `${sellingPlanID}`,
        };
      } else {
        bundleProductData = {
          variantId: `${this.currentVariant.id}`,
          productId: `${this.getAttribute('data-product-id')}`,
          sellingPlan: `${sellingPlanID}`,
        };
      }
    } else {
        bundleProductData = {
          variantId: `${this.currentVariant.id}`,
          productId: `${this.getAttribute('data-product-id')}`,
          sellingPlan: `${sellingPlanID}`,
      }
    }

    const selections = [];
    let contentsString = '';

    this.bundleSelects.forEach((item) => {
      const quantity = Number(item.querySelector('input')?.value);

      if (quantity > 0) {
        const obj = {
          collectionId: `${item.getAttribute('data-collection-id')}`,
          externalProductId: `${item.getAttribute('data-id')}`,
          externalVariantId: `${item.getAttribute('data-variant-id')}`,
          quantity: Number(item.querySelector('input')?.value),
        };
        contentsString += `${quantity}x ${item.getAttribute('data-title')} | `;

        selections.push(obj);
      }
    });

    // Remove last pipe if it exists
    contentsString = contentsString.replace(/\| $/, '');

    // Create the bundle object containing the selections
    const bundle = {
      externalVariantId: bundleProductData.variantId,
      externalProductId: bundleProductData.productId,
      selections: selections,
    };

    recharge.bundle
      .getBundleId(bundle)
      .then((id) => {
        if(skuSwapTrigger && this.currentVariant.id == Number(variantIdSKUSwap)){
          this.querySelector('[name="id"]').value = bundleProductData.variantId;
        }
        this.querySelector('[name="properties[_rb_id]"]').value = id;
        this.querySelector('[name="properties[Contents]"]').value =
          contentsString;
        let packaging_product;
        if(!this.variantName.innerHTML.includes('Hamper')){
          packaging_product = this.querySelector(
            '[id="packaging_product"]',
          )?.value;
        }
        const checkbox = document.querySelector(
          'input[name="opt_out_of_core_packaging"]',
        );
        const optOutOfCorePackaging = checkbox ? checkbox.checked : false;

        if (!packaging_product || optOutOfCorePackaging) {
          console.warn(
            "Packaging product not found or value is undefined. or customer doesn't want core packaging",
          );
        } else {
          console.warn('Packaging product ID:', packaging_product);
        }

        const formData = new FormData(this.form);

        formData.append(
          'sections',
          this.cartDrawer
            .getSectionsToRender()
            .map((section) => section.section),
        );

        formData.append('sections_url', window.location.pathname);

        // First Cart.add call for the main product
        return Cart.add(formData)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return Promise.reject('Error adding main product to cart');
            }

            // If there's no packaging product, render the cart drawer now
            if (!packaging_product || optOutOfCorePackaging) {
              updateCartCountBadge(response.item_count);
              this.cartDrawer.renderContents(response);
              this.cartDrawer.classList.add('is-open');
              return;
            }

            // Prepare the second product (packaging product) using formData2
            const formData2 = new FormData();
            formData2.append('id', packaging_product);
            formData2.append('quantity', 1);
            formData2.append('properties[_contents]', contentsString);
            formData2.append('properties[_is_packaging]', true);

            const selectedSellingPlanID = bundleProductData.sellingPlan;
            const selectedSellingPlanTitle = document.querySelector(
              'input[name="selling-plan-subscribe-radio"]:checked',
            ).dataset.title;

            if (selectedSellingPlanID) {
              const packagingSellingPlans = this.querySelectorAll(
                '[name="properties[_packaging_selling_plan]"]',
              );
              let matchingPackagingSellingPlan = null;
              packagingSellingPlans.forEach((plan) => {
                const packagingSellingPlanID = plan.value;
                const packagingSellingPlanName = plan.dataset.name;

                console.log(
                  'packagingSellingPlanName',
                  packagingSellingPlanName,
                );
                console.log(
                  'selectedSellingPlanTitle',
                  selectedSellingPlanTitle,
                );

                if (packagingSellingPlanName === selectedSellingPlanTitle) {
                  matchingPackagingSellingPlan = packagingSellingPlanID;
                }
              });

              if (matchingPackagingSellingPlan) {
                formData2.append('selling_plan', matchingPackagingSellingPlan);
              } else {
                console.warn(
                  'No matching selling plan found for the packaging product',
                );
              }
            } else {
              console.warn('No selling plan selected for the main product');
            }

            formData2.append(
              'sections',
              this.cartDrawer
                .getSectionsToRender()
                .map((section) => section.section),
            );

            formData2.append('sections_url', window.location.pathname);

            // Second Cart.add call for the packaging product
            return Cart.add(formData2)
              .then((response) => response.json())
              .then((response) => {
                if (response.status) {
                  this.handleErrorMessage(response.description);
                  return Promise.reject(
                    'Error adding packaging product to cart',
                  );
                }
                updateCartCountBadge(response.item_count);
                this.cartDrawer.renderContents(response);
                this.cartDrawer.classList.add('is-open');
              });
          });
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        // Re-enable the submit buttons after both products are added
        this.submitButtons.forEach((btn) => {
          btn.classList.remove('disabled');
          btn.value = btn.dataset.value;
        });
      });
  }

  /**
   * Handle sticky Add to cart.
   */
  handleStickyATC() {
    if (!this.stickyATC) {
      return;
    }

    const debouncedScrollHandler = debounce((event) => {
      this.scrollStickyATCHandler(event);
    }, 150);

    const quantityInput = this.stickyATC.querySelector('quantity-input input');
    const mainQuantityInput = this.querySelector('quantity-input input');

    document.addEventListener('scroll', debouncedScrollHandler);

    if (quantityInput && mainQuantityInput) {
      quantityInput.addEventListener('change', () => {
        mainQuantityInput.value = quantityInput.value;
      });

      mainQuantityInput.addEventListener('change', () => {
        quantityInput.value = mainQuantityInput.value;
      });
    }
  }

  scrollStickyATCHandler(e) {
    if (!this.submitButtons[0]) {
      return;
    }

    this.stickyATC.classList.toggle(
      'visible',
      !isElementInViewport(this.submitButtons[0]),
    );
  }

  /**
   * On variant change.
   *
   * @param {Object} event
   * @returns {Void}
   */
  onVariantChange(event) {
    if (event.target.type === 'number') return;
    this.updateOptions();
    this.updateVariant();
    this.handleErrorMessage();
    this.filterOptions();

    if (!this.currentVariant) {
      // Skip button update if setting is not selected
      if (this.options.some((option) => option.value == 'label')) {
        return;
      }

      this.setUnavailable();

      return;
    }

    if (!this.currentVariant.available) {
      this.toggleAddButton(true, window.variantStrings.soldOut);
    }

    this.updateVariantInput();
    this.updatePrice();

    if (event.target.type === 'number' || !this.currentVariant) {
      return;
    }

    this.updateMedia();
    this.updateURL();
    this.updateUnitPrices();
    this.updateVariantName();

    document.dispatchEvent(new CustomEvent('trigger:replace-combine-bundles', {
      detail: { variant: this.currentVariant }
    }));


  }

  updateVariantName() {
    if (!this.variantName || !this.currentVariant?.title) {
      return;
    }

    this.variantName.innerHTML = this.currentVariant?.title;
  }

  /**
   * Update quantity options unit prices.
   *
   * @returns {Void}
   */
  updateUnitPrices() {
    const sellingPlanID =
      this.querySelector('[name="selling_plan"]:checked')?.value || undefined;

    const currentPrice = sellingPlanID
      ? this.currentVariant?.selling_plan_allocations?.find(
          (sellingPlan) => sellingPlan.selling_plan_id == sellingPlanID,
        ).price
      : this.currentVariantPrice?.price_unformatted;

    this.querySelectorAll('quantity-swatch').forEach((swatch) => {
      swatch.updatePrice(currentPrice);
    });
  }

  /**
   * Update media.
   *
   * @returns {Void}
   */
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    const productMedia = document.querySelector('product-media');
    productMedia.setActiveMedia(this.currentVariant.featured_media.id);
  }

  /**
   * Update URL.
   *
   * @returns {Void}
   */
  updateURL() {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id,
    );
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?${params.toString()}`,
    );
  }
}

customElements.define(
  'main-product-selector-bundle',
  MainProductSelectorBundle,
);


if (!customElements.get('product-bundles-combined')) {
  class ProductBundlesCombined extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.defineElements();

      if (this.templates.length <= 1 && !this.replaceWrapper) {
        return;
      }

      this.addListeners();
    }

    defineElements() {
      this.templates =
          [...this.querySelectorAll('[data-js-bundle-combined-template]')];
      this.replaceWrapper =
          this.querySelector('product-bundles-combined-replacer');
    }

    addListeners() {
      document.addEventListener(
          'trigger:replace-combine-bundles',
          this.onVariantChange.bind(this));
    }

    onVariantChange(e) {
      const variant = e.detail.variant;

      this.setVariantAndBundleId(variant);


      if (!this.variantId || parseInt(this.selectedBundleId) === this.variantId) {
        return;
      } else {
        document.querySelectorAll('.product-selector__submit').forEach((btn) => btn.setAttribute('disabled', 'disabled'));
      }

      this.currentTemplate = this.getCurrentTemplate(this.variantId) || null;

      this.replaceBundles(this.currentTemplate);

    }

    getCurrentTemplate(id) {
     return this.templates.find((template) => {
        return parseInt(template.getAttribute('variant-id')) === id;
     })
    }

    setVariantAndBundleId(variant) {
      this.variantId = variant.id;
      this.selectedBundleId =
          this.getAttribute('selected-bundle-variant-id');
    }

    replaceBundles(template) {

      if (!template) {
        return null;
      }

      const templateContent = template.content.cloneNode(true)
      const childToReplace = this.replaceWrapper.firstElementChild;
      childToReplace?.replaceWith(templateContent);
      this.triggerChange();

    }

    triggerChange() {
      document.dispatchEvent(new CustomEvent('trigger:combined-bundle-replaced'));
      this.setAttribute('selected-bundle-variant-id', this.variantId);
    }

  }
  customElements.define('product-bundles-combined', ProductBundlesCombined);
}

/*
function incrementButton(quantityButtonId, productBundleSelectId) {
  document.querySelector(quantityButtonId).style.display = "none";
  document.querySelector(productBundleSelectId).style.display = "flex";
}*/

function moreInfo(id) {
  event.preventDefault();

  document.querySelector(id).style.display = "block";
  document.getElementById('more-info-overlay').style.display = "block";

  document.querySelector('#more-info-overlay').addEventListener('click', function() {
      document.querySelector(id).style.display = "none";
      document.getElementById('more-info-overlay').style.display = "none";
    }
  )

}

function moreInfoClose(id) {
  document.querySelector(id).style.display = "none";
  document.getElementById('more-info-overlay').style.display = "none";
}
